const getters = {
  allSkinTags: state => state.activity.allSkinTags,
  hotTags: state => state.activity.hotTags
}

export default getters
